import React from 'react';
import { PatientInterviewCardComponent } from '../../../components/Cards';

const PatientInterviewCard = () => <PatientInterviewCardComponent />;

export default PatientInterviewCard;
